module.exports = __webpack_public_path__ + "static/ASSET.01992ad8.png";